// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 735) return "static/chunks/735.4be63a2b82bd420c.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"280":"fff6ad29725677ce","956":"372e4c6b80551364"}[chunkId] + ".js";
};